import React, { useEffect, useState } from "react";
import ClickAwayListener from "react-click-away-listener";
import ImageGallery from "react-image-gallery";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { translate } from "react-switch-lang";
import { toast } from "react-toastify";
import { Container, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import SweetAlert from "sweetalert2";
import { ACTION } from "../../../../models/action";
import { CountryDto } from "../../../../models/countryDto";
import { ExpositionDto } from "../../../../models/expositionDto";
import { SortDirection } from "../../../../models/SortDirection";
import { StatisticMediaDto } from "../../../../models/statisticMediaDto";
import hasRoles from "../../../../security/hasRoles";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import keycloak from "../../../../security/keycloak-config";
import { RootState } from "../../../../store";
import AddImagesGallery from "../../../Support/add-images-gallery/addImagesGallery";
import UpdateImagesGallery from "../../../Support/update-images-gallery/updateImagesGallery";
import GalleryItem from "../gallery-image-item/GalleryImageItem";
import styles from "./galleryImages.module.scss";
import "./stylesGallery.css";

const GalleryImages = (props: any) => {
  toast.configure();
  const httpClient = useHttpClient(false);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [openModalAddSupport, setOpenModalAddSupport] = useState<boolean>(false);
  const location = useLocation();
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortIcon, setSortIcon] = useState<string>("sort");
  const [sortDirection, setSortDirection] = useState(SortDirection.SORT);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [openModalViewer, setOpenModalViewer] = useState<boolean>(false);
  const [listExposition, setListExposition] = useState<any>(new ExpositionDto());
  const [exposition, setExposition] = useState<any>(new ExpositionDto());
  const [openModalGallery, setOpenModalGallery] = useState<boolean>(false);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [indexVideo, setIndexVideo] = useState<number>(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeStep, _] = React.useState(0);
  
  const [deepLinkExpo, setDeepLinkExpo] = useState<any>(null);
  const [deepLinkIndex, setDeepLinkIndex] = useState<number>(0);
  const [openDeepLinkModal, setOpenDeepLinkModal] = useState<boolean>(false);

  const _handlerListener = () => {
    let params = { categoryId: props.categoryId, sortDirection: "ASC", sortColumn: "titleFr", page: "0", size: "5" };
    httpClient.current?.get("/exposition/search", { params: params }).then(res => {
      props.setFilteredDocuments(res.data.content.map(data => data.content));
      props.setTotlaElement(res.data.totalElements);
    });
  };

  useEffect(() => {
    _handlerListener();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const handleClickOpenModalAddSupport = () => {
    setOpenModalAddSupport(!openModalAddSupport);
  };

  

  const sortTrainingPathList = (sortColumnName: string, isStatisticColumn: boolean) => {
    let params = { categoryId: props.categoryId, sortDirection: "ASC", sortColumn: sortColumnName, page: 0, size: props.elementPerPage };
    setSortColumn(sortColumnName);
    props.setSortColumnTitle(sortColumnName)
    let asc = false;
    if (sortDirection === SortDirection.SORT || sortDirection === SortDirection.SORT_DESC || sortColumnName !== sortColumn) {
      asc = true;
      params.sortDirection = "ASC";
      setSortIcon("sort-asc");
    } else {
      params.sortDirection = "DESC";
      asc = false;
      setSortIcon("sort-desc");
    }
    if (isStatisticColumn) {
      asc ? setSortDirection(SortDirection.SORT_ASC) : setSortDirection(SortDirection.SORT_DESC);
      props.filteredDocuments.sort(compareStatisticView);
      if (asc) {
        props.filteredDocuments.reverse();
      }
    } else {
      props.setSortOrder(params.sortDirection);
      httpClient.current?.get("/exposition/search", { params: params }).then(res => {
        props.setFilteredDocuments(res.data.content.map(data => data.content));
        asc ? setSortDirection(SortDirection.SORT_ASC) : setSortDirection(SortDirection.SORT_DESC);
      });
    }
  };

  const compareStatisticView = (a, b) => {
    if (a.numberView < b.numberView) {
      return -1;
    }
    if (a.numberView > b.numberView) {
      return 1;
    }
    return 0;
  };

  function getSortIconClassName(columnName: string) {
    if (sortColumn === columnName) {
      return "fa fa-" + sortIcon;
    } else {
      return "fa fa-sort";
    }
  }

  const handleClickOpenModalViewer = (data: ExpositionDto) => {
    if (!openModalViewer) {
      if (!hasRoleAdmin) {
        let statisticMediaDto = new StatisticMediaDto();
        statisticMediaDto.categoryId = data.categoryId;
        statisticMediaDto.typeCategory = "2";
        statisticMediaDto.mediaId = data.expositionId;
        statisticMediaDto.action = ACTION.VIEW;
        httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
      }
      setOpenModalViewer(!openModalViewer);
    } else {
      setOpenModalViewer(!openModalViewer);
    }
    if (data.listExpositionImage) setListExposition(data?.listExpositionImage?.map(img => ({ original: img.urlImage, thumbnail: img.urlImage })));
  };

  const handleClickOpenModalUpdateGallery = () => {
    setOpenModalGallery(!openModalGallery);
  };

  const deleteExposition = (expositionId: number) => {
    SweetAlert.fire({
      title: props.t("message_confirmation_delete_exhibit"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/exposition/" + expositionId).then(response => {
          toast.success(props.t("message_toastr_delete"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          props.handleGetListSupport();
          props.resetAllFieldSearch();
        });
      } else {
      }
    });
  };

  const toggle = index => {
    setDropdownOpen(!dropdownOpen);
    setIndexVideo(index);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const expositionIdParam = params.get("expositionId");
    const imageIndexParam = params.get("imageIndex");

    if (expositionIdParam) {
      httpClient.current?.get("/exposition/" + expositionIdParam).then(res => {
        console.log(res.data);
        setDeepLinkExpo(res.data);
        setDeepLinkIndex(imageIndexParam ? parseInt(imageIndexParam, 10) : 0);
        setOpenDeepLinkModal(true);
      });
    }

    // Always load the normal list regardless
    _handlerListener();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  return (
    <>
      <Container className={styles["documents-wrapper"]} fluid={true}>
        <Row>
          <Modal isOpen={openModalAddSupport} toggle={handleClickOpenModalAddSupport} size="lg">
            <ModalHeader toggle={handleClickOpenModalAddSupport}>{"Nouvelle exposition de photos"}</ModalHeader>
            <ModalBody>
              <AddImagesGallery
                handlerListener={_handlerListener}
                closeToggle={handleClickOpenModalAddSupport}
                resetAllFieldSearch={() => {
                  props.resetAllFieldSearch();
                }}
                categoryId={location.pathname.split("/")[3]}
                setFilteredDocuments={props.setFilteredDocuments}
                path={location.pathname.split("/")[2]}
              ></AddImagesGallery>
            </ModalBody>
          </Modal>
          {!props.filteredDocuments.length && (
            <div style={{ width: "100%" }} className="text-center">
              {props.t("message_no_exhibit")}
            </div>
          )}
          {props.isListDisplayMode &&
            props.filteredDocuments.map((element, index: number) => {
              return (
                <GalleryItem
                  deleteExposition={deleteExposition}
                  setFilteredDocuments={props.setFilteredDocuments}
                  key={index}
                  resetAllFieldSearch={() => {
                    props.resetAllFieldSearch();
                  }}
                  info={element}
                  handlerListener={_handlerListener}
                  exposition={element?.listExpositionImage}
                  filterLanguage={props.filterLanguage} 
                />
              );
            })}
          {!props.isListDisplayMode && props.filteredDocuments.length > 0 && (
            <Row className={styles["document-table-row"]}>
              <div className={styles["container-table"]}>
                <Table className={styles["document-table"]}>
                  <thead>
                    <tr>
                      <th className={styles["document-table-icon"]} scope="col"></th>
                      <th className={styles["document-table-nom"]} scope="col">
                        <span onClick={() => sortTrainingPathList(selectedLanguage === "en" ? "titleEn" : "titleFr", false)} className={styles["pointer"]}>
                          <i className={getSortIconClassName(selectedLanguage === "en" ? "titleEn" : "titleFr")}></i> {props.t("table_header.title")}
                        </span>
                      </th>
                      <th className={styles["document-table-thematique"]} scope="col">
                        {props.t("table_header.thematic")}
                      </th>
                      <th className={styles["document-table-date"]} scope="col">
                        <span onClick={() => sortTrainingPathList("dateExposition", false)} className={styles["pointer"]}>
                          <i className={getSortIconClassName("dateExposition")}></i> {props.t("table_header.date")}
                        </span>
                      </th>
                      <th className={styles["document-table-pays"]} scope="col">
                        {props.t("table_header.country")}
                      </th>
                      <th className={styles["document-table-description"]} scope="col">
                        {props.t("table_header.description")}
                      </th>
                      {hasRoleAdmin && (
                        <th className={styles["document-table-date"]} scope="col">
                          <span onClick={() => sortTrainingPathList("view", true)} className={styles["pointer"]}>
                            <i className={getSortIconClassName("view")}></i> <i className="fa fa-eye"></i>
                          </span>
                        </th>
                      )}
                      {hasRoleAdmin && (
                        <th className={styles["document-table-actions"]} scope="col">
                          {props.t("table_header.actions")}
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {props.filteredDocuments.map((data: ExpositionDto, index: number) => (
                      <tr key={data.expositionId}>
                        <td className="align-middle">
                          <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
                            <div className="product-img text-center">
                              <img onClick={() => handleClickOpenModalViewer(data)} className={styles["table-img"] + " img-100"} src={data?.listExpositionImage[0]?.urlImage} alt="" />
                          <div className={styles["product-hover"] + " product-hover"}>
                          <ul>
                            <li
                              onClick={() => handleClickOpenModalViewer(data)}
                              style={{ width: "auto", cursor: "pointer" }}
                            >
                              <i className="icon-eye">
                                <span className="m-l-5">{hasRoleAdmin && data.numberView}</span>
                              </i>
                            </li>
                          </ul>
                            </div>
                            </div>
                          </div>
                        </td>
                        <td className="align-middle">{selectedLanguage === "en" ? data.titleEn : data.titleFr}</td>
                        <td className="align-middle">
                          {data.listThematic.map(thematic => (
                            <span key={thematic.thematicId} className="p-l-5">
                              {thematic.titleFrancais}
                            </span>
                          ))}
                        </td>
                        <td className="align-middle">{data.dateExposition}</td>
                        <td className="align-middle">
                          {data.listCountry.map((country: CountryDto) => (
                            <span key={country.countryId} className="p-l-5">
                              {country.titleFrancais}
                            </span>
                          ))}
                        </td>
                        <td className="align-middle">{selectedLanguage === "en" ? data.descriptionEn : data.descriptionFr}</td>
                        {hasRoleAdmin && <td className="align-middle">{data.numberView}</td>}
                        {hasRoleAdmin && (
                          <td onClick={event => event.stopPropagation()} className={`${styles["document-table-actions-icons"]} align-middle text-center`}>
                            <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
                              <div className={`${styles["translate_wrapper-view"]} ${dropdownOpen && index === indexVideo ? styles["active"] : ""}`}>
                                <div onClick={event => event.stopPropagation()} className={styles["current_lang-view"]}>
                                  <div
                                    className={styles["lang-view"] + " " + styles["label-list-view"]}
                                    onClick={event => {
                                      event.stopPropagation();
                                      toggle(index);
                                    }}
                                  >
                                    <i className={"fa fa-ellipsis-v  " + styles["icon-point"]}></i>
                                  </div>
                                </div>
                                <div className={`${styles["more_lang-view"]} ${dropdownOpen && index === indexVideo ? styles["active"] : ""}`}>
                                  <div
                                    className={styles["lang-view"]}
                                    onClick={event => {
                                      event.stopPropagation();
                                      handleClickOpenModalUpdateGallery();
                                      setExposition(data);
                                    }}
                                  >
                                    <i id="tableIconBtn" className={`${styles["document-actions__btn-share"]} fa fa-share-alt`}></i>
                                    <span className={styles["lang-txt-view"]}>{props.t("button_share") || "Partager"}</span>
                                    <i id="tableIconBtn" className={`${styles["document-actions__btn-update"]}  fa fa-edit m-t-5`}></i>
                                    <span className={styles["lang-txt-view"]}>{props.t("button_update")}</span>
                                  </div>
                                  <div
                                    className={styles["lang-view"]}
                                    onClick={event => {
                                      event.stopPropagation();
                                      deleteExposition(data.expositionId);
                                    }}
                                  >
                                    <i id="tableIconBtn" className={`${styles["document-actions__btn-delete"]} fa fa-trash-o `}></i>
                                    <span className={styles["lang-txt-view"]}>{props.t("button_delete")}</span>
                                  </div>
                                </div>
                              </div>
                            </ClickAwayListener>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Row>
          )}
        </Row>
        {/* MODIFIE : Vérification de listExposition */}
        <Modal isOpen={openModalViewer} toggle={() => handleClickOpenModalViewer(new ExpositionDto())} size="lg">
          <ModalBody>
            {listExposition && listExposition.length > 0 ? (
              <ImageGallery
                items={listExposition}
                thumbnailPosition={"bottom"}
                showBullets={true}
                showPlayButton={true}
              />
            ) : (
              <p>Aucune image disponible.</p>
            )}
          </ModalBody>
        </Modal>
        <Modal isOpen={openModalGallery} toggle={handleClickOpenModalUpdateGallery} size="lg">
          <ModalBody className="p-0">
            <div>
              <h6 className={styles["title-model"] + " "}>{props.t("title_update_exhibit")}</h6>
            </div>
            <UpdateImagesGallery
              type={null}
              exposition={exposition}
              getListSupport={_handlerListener}
              onUpdate={_handlerListener}
              closeToggle={handleClickOpenModalUpdateGallery}
              resetAllFieldSearch={() => {
                props.resetAllFieldSearch();
              }}
              categoryId={location.pathname.split("/")[3]}
              path={location.pathname.split("/")[2]}
            ></UpdateImagesGallery>
          </ModalBody>
        </Modal>
      </Container>
      {deepLinkExpo && (
        <Modal
          isOpen={openDeepLinkModal}
          toggle={() => {
            setOpenDeepLinkModal(false);
            // ← Clean URL params without reloading the page
            window.history.replaceState({}, "", window.location.pathname);
          }}
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              setOpenDeepLinkModal(false);
              window.history.replaceState({}, "", window.location.pathname);
            }}
          ></ModalHeader>
          <ModalBody>
            <ImageGallery
              items={deepLinkExpo.listExpositionImage.map(img => ({
                original: img.urlImage,
                thumbnail: img.urlImage,
              }))}
              thumbnailPosition={"bottom"}
              showBullets={true}
              showPlayButton={true}
              startIndex={deepLinkIndex}
            />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default translate(GalleryImages);
